import { render, staticRenderFns } from "./auto_view.vue?vue&type=template&id=6c724754&scoped=true"
import script from "./auto_view.vue?vue&type=script&lang=js"
export * from "./auto_view.vue?vue&type=script&lang=js"
import style0 from "./auto_view.vue?vue&type=style&index=0&id=6c724754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c724754",
  null
  
)

export default component.exports